<template>
  <div>
    <form
      ref="form"
      @submit.prevent="checkForm"
    >
      <!-- 모달 컨텐츠 -->
      <div class="modal__contents">
        <div class="modal__middlebox">
          <div class="modal__row">
            <h2 class="subtitle subtitle--modal">
              각 디바이스 별 최적화 방식을 선택 해주세요
            </h2>
          </div>
          <div class="modal__row">
            <div class="formfield">
              <ul class="formfield__row">
                <li class="formfield__inputitem">
                  <div class="radio">
                    <input
                      id="resoponsive"
                      v-model="req.optimization.type"
                      class="radio__input" 
                      type="radio"
                      name="type"
                      value="반응형/적응형"
                      :disabled="req.optimization.tbd"
                    >
                    <label
                      class="radio__label"
                      for="resoponsive"
                    >
                      반응형/적응형
                    </label>
                  </div>
                </li>
                <li class="formfield__inputitem">
                  <div class="radio">
                    <input
                      id="seperate"
                      v-model="req.optimization.type"
                      class="radio__input" 
                      type="radio"
                      name="type"
                      value="디바이스 별"
                      :disabled="req.optimization.tbd"
                    >
                    <label
                      class="radio__label"
                      for="seperate"
                    >
                      디바이스 별 별도 제작
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>            
        </div>
        <div class="modal__bottombox">  
          <div class="checkbox">
            <input
              id="check"
              v-model="req.optimization.tbd"
              class="checkbox__input"
              type="checkbox"
              name="check"
            >
            <label
              class="checkbox__label"
              for="check"
            >
              아직 결정되지 않았습니다.
            </label>
          </div>
        </div>
      </div>
      <!-- 모달 푸터(bottom) -->
      <div class="modal__footer">
        <ul class="modal__buttons">     
          <li class="modal__buttonitem">
            <button
              type="button"
              class="button button--large button--secondary"
              @click="save"
            >
              임시저장
            </button>
          </li>
          <li class="modal__buttonitem">
            <button
              type="submit"
              class="button button--large"
              :disabled="!req.optimization.type && !req.optimization.tbd"
            >
              다음
            </button>
          </li>
        </ul>
      </div>
      <!-- 모달 이전 -->
      <div class="modal__prevbutton">
        <button
          class="button button--function"
          @click="$emit('prev-step')"
        >
          이전
        </button>
      </div>
    </form>
  </div>
</template>
<script>
export default{
  name:'Optimiation',
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  emits: ['next-step', 'prev-step', 'save-click'],
  data(){
    return {
      req: this.request
    }
  },
  methods:{
    checkForm() {
      this.$emit('next-step')
    },
    save() {
      this.$emit('save-click')
    }
  }
}
</script>
<style lang="scss" scoped>
.modal{
  $self:&;  
  &__buttons{
    width:330px;
    margin:0 auto;
    &:after{
      content:'';
      clear:both;
      display:inline;
    }
  }
  &__buttonitem{
    float:left;
    width:160px;
    height:50px;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
.formfield{
  &__row{
    width:490px;
    margin:0 auto;
}
  &__inputitem{
    float:left;    
    width:240px;
    height:50px; 
    position: relative;    
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
</style>